<template>
  <div class="home">
    <div >
            <div>
                <section>
                    <div class="py-8 px-8">
                    <div class="d-flex flex-wrap align-items-center justify-content-between">
                        <div class="col-12 col-lg-auto mb-3 mb-lg-0">
                            <div class="d-flex align-items-center">
                                <h4 class="mb-0 me-2">{{$t('suppliers')}}</h4>
                            </div>
                        </div>
                        <div class="col-12 col-lg-auto d-flex align-items-center gap-2">
                            <div class="input-group flex-grow-1" style="border-bottom: 1px solid #ddd;">
                                <input class="form-control border-0 search-input" autocomplete="off" type="text" v-model="search" :placeholder="$t('search')">
                            </div>
                            <!-- Mobile filter toggle -->
                            <button @click="showFilters = !showFilters" class="btn btn-outline-secondary d-md-none">
                                <AppIcon name="bi-sliders" class="bi bi-sliders" />
                            </button>
                        </div>
                    </div>
                    </div>
                </section>
            </div>
      
            <section class="">
                <div class="px-8">
                    
                   <!-- Mobile action buttons -->
                   <div class="d-flex d-md-none gap-2 mb-3">
                        <template v-if="helper.checkAccess('create_suppliers') != -1">
                            <button @click="create" class="btn btn-sm btn-success flex-grow-1">
                                <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
                                <span>{{$t('supplier')}}</span>
                            </button>
                        </template>

                        <div class="dropdown">
                            <button class="btn btn-sm btn-light" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                                <AppIcon name="bi-three-dots-vertical" class="bi bi-three-dots-vertical" />
                            </button>
                            <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
                                <li v-if="helper.checkAccess('create_suppliers') != -1">
                                    <a class="dropdown-item" href="#" @click="showUpload">{{$t('upload')}}</a>
                                </li>
                                <li>
                                    <a class="dropdown-item" href="#" @click="generatePDF">{{$t('generate_pdf')}}</a>
                                </li>
                            </ul>
                        </div>
                   </div>

                   <!-- Filters section -->
                   <div class="row align-items-end g-2 mb-4" :class="{'d-none d-md-flex': !showFilters}">
                        
                        <!-- Filter Dropdown (Shopify Style) -->
                        <div class="col-12 col-md-auto">
                            <div class="dropdown">
                                <button class="btn btn-outline-secondary dropdown-toggle btn-sm" type="button" id="filterDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                    <AppIcon name="bi-funnel" class="bi bi-funnel" /> {{$t('filter')}}
                                    <span v-if="activeFilters.length" class="badge bg-secondary ms-1">{{activeFilters.length}}</span>
                                </button>
                                <button v-if="activeFilters.length" class="btn btn-link btn-sm text-danger text-decoration-none ms-2" type="button" @click.stop="clearAllFilters">
                                    <AppIcon name="bi-x-circle" class="bi bi-x-circle me-1" />{{$t('clear_all')}}
                                </button>
                                <div class="dropdown-menu p-3" aria-labelledby="filterDropdown" style="min-width: 300px;" @click.stop>
                                    
                                    <!-- Active Filters -->
                                    <div v-if="activeFilters.length > 0" class="mb-3">
                                        <div v-for="(filter, index) in activeFilters" :key="index" class="mb-2">
                                            <label class="form-label small mb-1">{{$t(filter.key)}}</label>
                                            <div class="input-group input-group-sm">
                                                <input type="text" v-model="filter.value" class="form-control form-control-sm" :placeholder="$t(filter.key)">
                                                <button class="btn btn-outline-danger" type="button" @click="removeFilter(index)">
                                                    <AppIcon name="bi-trash" class="bi bi-trash" />
                                                </button>
                                            </div>
                                        </div>
                                        <hr class="dropdown-divider">
                                    </div>

                                    <!-- Add Filter Options -->
                                    <div class="d-grid gap-2">
                                        <button v-for="filter in selectableFilters" :key="filter.key" 
                                                class="btn btn-sm btn-outline-primary text-start" 
                                                @click="addFilter(filter)">
                                            <AppIcon name="bi-plus" class="bi bi-plus" /> {{$t(filter.key)}}
                                        </button>
                                    </div>

                                    <!-- Apply and Clear -->
                                    <div class="d-flex justify-content-between align-items-center mt-3">
                                        <button class="btn btn-sm btn-success" @click="applyFilters">
                                            {{$t('apply')}}
                                        </button>
                                        <button v-if="activeFilters.length > 0" class="btn btn-link btn-sm text-decoration-none text-danger p-0" @click="clearAllFilters">
                                            {{$t('clear_all')}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Spacer for desktop -->
                        <div class="col d-none d-md-block"></div>

                        <div class="col-12 col-md-3 col-lg-2">
                            <label class="form-label small d-md-none mb-1">{{$t('filter_by_date')}}</label>
                            <select v-model="dateRangeOption" @change="handleDateRangeChange" class="form-select form-select-sm">
                                <option value="">{{$t('filter_by_date')}}</option>
                                <option value="today">{{$t('today')}}</option>
                                <option value="yesterday">{{$t('yesterday')}}</option>
                                <option value="this_week">{{$t('this_week')}}</option>
                                <option value="last_week">{{$t('last_week')}}</option>
                                <option value="this_month">{{$t('this_month')}}</option>
                                <option value="custom">{{$t('custom_date')}}</option>
                            </select>
                        </div>
                        <div class="col-12 col-md-3 col-lg-2" v-if="dateRangeOption === 'custom'">
                            <label class="form-label small d-md-none mb-1">{{$t('custom_date')}}</label>
                            <date-picker :clearable="true" :editable="false" class="w-100" v-model="range" type="date" range :multi-calendars="1" :placeholder="$t('select_date_range')"></date-picker>
                        </div>
                        <template v-if="helper.checkAccess('create_suppliers') != -1">
                            <div class="col-md-2 d-none d-md-block">
                                <button @click="create" class="btn btn-sm btn-success w-100">
                                <span class="d-inline-block me-2 .text-primary-dark">
                                    <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
                                </span>
                                <span>{{$t('supplier')}}</span>
                            </button>
                        </div>
                    </template>
                    </div>
                <div class="page-table-container mb-6 bg-white rounded shadow">

                    <!-- table -->
                    <div data-testid="supplier-table-scroll" class="table-responsive">
                        <table class="table mb-0 table-borderless table-striped small sticky-action-table" style="--sales-document-table-min-width: 1500px;">
                            <thead>
                                <tr class="text-secondary">
                                    <th class="pt-4 pb-3 px-6" style="width: 40px;">
                                        <div class="form-check mb-0">
                                            <input class="form-check-input" type="checkbox" :checked="areAllSelected" @change="toggleSelectAll">
                                        </div>
                                    </th>
                                    <sortable-table-header v-if="visibleColumns.reference" field="reference" label="reference" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getSuppliers)" />
                                    <sortable-table-header v-if="visibleColumns.name" field="name" label="name" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getSuppliers)" />
                                    <sortable-table-header v-if="visibleColumns.phone" field="phone" label="phone" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getSuppliers)" />
                                    <sortable-table-header v-if="visibleColumns.email" field="email" label="email" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getSuppliers)" />
                                    <sortable-table-header v-if="visibleColumns.address" field="address" label="address" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getSuppliers)" />
                                    <sortable-table-header v-if="visibleColumns.city" field="city" label="city" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getSuppliers)" />
                                    <sortable-table-header v-if="visibleColumns.state" field="state" label="state" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getSuppliers)" />
                                    <sortable-table-header v-if="visibleColumns.zip_code" field="zip_code" label="zip_code" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getSuppliers)" />
                                    <sortable-table-header v-if="visibleColumns.country" field="country" label="country" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getSuppliers)" />
                                    <sortable-table-header v-if="visibleColumns.tax_id" field="tax_id" label="tax_id" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getSuppliers)" />
                                    <sortable-table-header v-if="visibleColumns.vat_number" field="vat_number" label="vat_number" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getSuppliers)" />
                                    <th v-if="visibleColumns.ltv" class="pt-4 pb-3 px-6">{{$t('ltv')}}</th>
                                    <th v-if="visibleColumns.amount_paid" class="pt-4 pb-3 px-6">{{$t('amount_paid')}}</th>
                                    <th v-if="visibleColumns.balance_due" class="pt-4 pb-3 px-6">{{$t('supplier_balance_due')}}</th>
                                    <th v-if="visibleColumns.overdue" class="pt-4 pb-3 px-6">{{$t('overdue')}}</th>
                                    <sortable-table-header v-if="visibleColumns.created_at" field="created_at" label="created_at" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getSuppliers)" />
                                    <th v-if="visibleColumns.created_by" class="pt-4 pb-3 px-6">{{$t('created_by')}}</th>
                                    <th v-if="visibleColumns.action" class="pt-4 pb-3 px-6 sticky-action-cell">
                                        <div class="d-flex align-items-center justify-content-between">
                                            <span>{{$t('action')}}</span>
                                            <div class="dropdown">
                                                <button class="btn btn-sm btn-link p-0 ms-2" type="button" data-bs-toggle="dropdown" aria-expanded="false" title="Columns">
                                                    <AppIcon name="bi-three-dots-vertical" class="bi bi-three-dots-vertical" />
                                                </button>
                                                <ul class="dropdown-menu dropdown-menu-end p-2" style="min-width: 200px; max-height: 300px; overflow-y: auto;">
                                                    <li v-if="helper.checkAccess('create_suppliers') != -1">
                                                        <a class="dropdown-item" href="#" @click="showUpload">{{$t('upload')}}</a>
                                                    </li>
                                                    <li>
                                                        <a class="dropdown-item" href="#" @click="generatePDF">{{$t('generate_pdf')}}</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                            <tr v-for="supplier in suppliers" :key="supplier.id" :class="{'table-active': supplier.selected}">
                                <td class="py-5 px-6">
                                    <div class="form-check mb-0">
                                        <input class="form-check-input" type="checkbox" v-model="supplier.selected" @change="changeSelectedItem">
                                    </div>
                                </td>
                                <td v-if="visibleColumns.reference" class="py-5 px-6"> <router-link :to="`/suppliers/${supplier.id}`"><b>{{supplier.reference}}</b></router-link></td>
                                <td v-if="visibleColumns.name" class="py-5 px-6">
                                    <span :title="supplier.name || '-'" :aria-label="supplier.name || '-'">{{truncateEntityName(supplier.name)}}</span>
                                </td>
                                <td v-if="visibleColumns.phone" class="py-5 px-6">{{supplier.phone}}</td>
                                <td v-if="visibleColumns.email" class="py-5 px-6">{{supplier.email}}</td>
                                <td v-if="visibleColumns.address" class="py-5 px-6">
                                    <span class="supplier-address" :title="supplier.address || '-'">{{truncateAddress(supplier.address)}}</span>
                                </td>
                                <td v-if="visibleColumns.city" class="py-5 px-6">{{supplier.city || '-'}}</td>
                                <td v-if="visibleColumns.state" class="py-5 px-6">{{supplier.state || '-'}}</td>
                                <td v-if="visibleColumns.zip_code" class="py-5 px-6">{{supplier.zip_code || '-'}}</td>
                                <td v-if="visibleColumns.country" class="py-5 px-6">{{supplier.country || '-'}}</td>
                                <td v-if="visibleColumns.tax_id" class="py-5 px-6">{{supplier.tax_id || '-'}}</td>
                                <td v-if="visibleColumns.vat_number" class="py-5 px-6">{{supplier.vat_number || '-'}}</td>
                                <td v-if="visibleColumns.ltv" class="py-5 px-6">{{ formatMoney(supplier.invoices.filter(invoice => invoice.status !== 'canceled').reduce((sum, invoice) => sum + invoice.total, 0).toFixed(2)) }} </td>
                                <td v-if="visibleColumns.amount_paid" class="py-5 px-6">{{ formatMoney(supplier.transactions.filter(transaction => transaction.status === 'paid').reduce((sum, transaction) => sum + transaction.amount, 0).toFixed(2)) }} </td>
                                <td v-if="visibleColumns.balance_due" class="py-5 px-6 fw-bold">{{formatMoney(supplierBalanceDue(supplier))}}</td>
                                <td v-if="visibleColumns.overdue" class="py-5 px-6 fw-bold" :class="{'text-danger': supplierOverdueAmount(supplier) > 0}">{{formatMoney(supplierOverdueAmount(supplier))}}</td>
                                <td v-if="visibleColumns.created_at" class="py-5 px-6">{{formatDate(supplier.created_at)}}</td>
                                <td v-if="visibleColumns.created_by" class="py-5 px-6">
                                    {{supplier.user ? supplier.user.name : '-'}}
                                    </td>
                                <td v-if="visibleColumns.action" class="py-5 px-6 sticky-action-cell">
                                    <div class="sticky-row-actions">
                                    <button @click="goDetails(supplier.id)" style="padding: 5px;margin: 0;font-size: 12px !important;margin-right:2px" class="btn btn-primary btn-xs">
                                        <AppIcon name="bi-eye" class="bi bi-eye" />
                                        {{$t('details')}}
                                    </button>
                                    <button v-if="helper.checkAccess('edit_suppliers') != -1" @click="editRow(supplier)" style="padding: 5px;margin: 0;font-size: 12px !important;margin-right:2px" class="btn btn-primary btn-xs">
                                        <AppIcon name="bi-pencil" class="bi bi-pencil" style="font-size:12px" />
                                        {{$t('edit')}}
                                    </button>
                                    <button v-if="helper.checkAccess('delete_suppliers') != -1" @click="deleteRow(supplier)" style="padding: 5px;margin: 0;font-size: 12px !important;" class="btn btn-primary btn-xs">
                                        <AppIcon name="bi-trash" class="bi bi-trash" style="font-size:12px" />
                                        {{$t('delete')}}
                                    </button>
                                    </div>
                                </td>
                            </tr>

                            </tbody>
                        </table>

                        <div v-if="count > suppliers.length" style="text-align:center;margin-top:1rem;margin-bottom:1rem">
                            <compact-pagination :pages="pagination" :current-page="page" @change="getSuppliers" />
                        </div>
                    </div>
                    <!-- table -->
                    <table-loading-bar v-if="loading" class="page-table-state text-center" />
                    <div v-if="loading === false && !suppliers.length && !isFiltered" class="page-table-state text-center py-5 my-5 bg-white rounded shadow-sm border" style="border-style: dashed !important;">
                        <AppIcon name="bi-truck" class="bi bi-truck text-muted" style="font-size: 3rem;" />
                        <h4 class="mt-3">{{ $t('no_suppliers_added') }}</h4>
                        <p class="text-muted">{{ $t('start_by_adding_suppliers') }}</p>
                        <template v-if="helper.checkAccess('create_suppliers') != -1">
                            <button class="btn btn-outline-primary mt-2" @click="create">
                                {{ $t('add_first_supplier') }}
                            </button>
                        </template>
                    </div>
                    <div v-if="loading === false && !suppliers.length && isFiltered" class="page-table-state text-center" style="padding:1rem">{{$t('no_supplier_found')}}.</div>
                </div>

                    <div class="col-sm-7">
                           {{$t('show')}}
                            <select v-model="per_page" class="form-select mb-3" name="Resulats" style="cursor:pointer;margin-right: 5px;width:100px;display:inline-block">
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="15">15</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            {{$t('entities')}}
                        </div>
                </div>
            </section>
      </div>

        <!-- Bulk Action Bar -->
        <div v-if="isSelectedItem" class="position-fixed bottom-0 start-50 translate-middle-x mb-4 p-3 bg-white shadow rounded d-flex align-items-center gap-3" style="z-index: 1050; border: 1px solid #dee2e6; min-width: 300px; justify-content: space-between;">
            <div class="d-flex align-items-center">
                <span class="fw-bold me-2">{{ selectedCount }}</span>
                <span class="text-muted">{{$t('selected')}}</span>
            </div>
            <div class="d-flex gap-2">
                <button v-if="helper.checkAccess('delete_suppliers') != -1" class="btn btn-danger btn-sm d-flex align-items-center" @click="deleteSelected">
                    <AppIcon name="bi-trash" class="bi bi-trash me-1" /> {{$t('delete')}}
                </button>
            </div>
        </div>

        <!-- Upload Modal -->
        <div class="modal fade" id="uploadModal" tabindex="-1" aria-labelledby="uploadModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="uploadModalLabel">{{$t('upload_suppliers')}}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <import-supplier @upload-success="uploadSuccess"></import-supplier>
            </div>
            </div>
        </div>
        </div>

        <!-- create Modal -->
        <div class="modal fade" id="supplier-create-modal" tabindex="-1" aria-labelledby="supplier-create-modal" aria-hidden="true">
            <div class="modal-dialog modal-xl">
                <div class="modal-content modern-modal">
                <div class="modal-header border-0 pb-0">
                    <div>
                        <h5 class="modal-title mb-0">
                            <AppIcon name="bi-building" class="bi bi-building me-2" />
                            {{$t('create_supplier')}}
                        </h5>
                    </div>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
                </div>
                <div class="modal-body pt-2" style="text-align:left">
                    <div class="supplier-create-fields">
                        <div class="supplier-create-field">
                            <label for="createLabelInput" class="form-label">
                                {{$t('label')}} <span class="text-danger">*</span>
                            </label>
                            <div class="input-group">
                                <span class="input-group-text bg-light border-end-0">
                                    <AppIcon name="bi-person" class="bi bi-person" />
                                </span>
                                <input 
                                    v-model="supplier.name" 
                                    type="text" 
                                    class="form-control border-start-0 ps-0" 
                                    :class="{'is-invalid': validationErrors.name}"
                                    id="createLabelInput"
                                    @blur="validateField('name')"
                                >
                            </div>
                            <div v-if="validationErrors.name" class="invalid-feedback d-block">
                                {{validationErrors.name}}
                            </div>
                        </div>
                        <div v-if="isSupplierFieldVisible('phone')" class="supplier-create-field">
                            <label for="createPhoneInput" class="form-label">
                                {{$t('phone')}} <span class="text-danger">*</span>
                            </label>
                            <div class="input-group">
                                <span class="input-group-text bg-light border-end-0">
                                    <AppIcon name="bi-telephone" class="bi bi-telephone" />
                                </span>
                                <input 
                                    v-model="supplier.phone" 
                                    type="tel" 
                                    class="form-control border-start-0 ps-0"
                                    :class="{'is-invalid': validationErrors.phone}"
                                    id="createPhoneInput"
                                    @blur="validateField('phone')"
                                >
                            </div>
                            <div v-if="validationErrors.phone" class="invalid-feedback d-block">
                                {{validationErrors.phone}}
                            </div>
                        </div>
                        <div v-if="isSupplierFieldVisible('email')" class="supplier-create-field">
                            <label for="createEmailInput" class="form-label">{{$t('email')}}</label>
                            <div class="input-group">
                                <span class="input-group-text bg-light border-end-0">
                                    <AppIcon name="bi-envelope" class="bi bi-envelope" />
                                </span>
                                <input 
                                    v-model="supplier.email" 
                                    type="email" 
                                    class="form-control border-start-0 ps-0"
                                    :class="{'is-invalid': validationErrors.email}"
                                    id="createEmailInput"
                                    @blur="validateField('email')"
                                >
                            </div>
                            <div v-if="validationErrors.email" class="invalid-feedback d-block">
                                {{validationErrors.email}}
                            </div>
                        </div>
                        <div v-if="isSupplierFieldVisible('address')" class="supplier-create-field supplier-create-field--full">
                            <label for="createAddressInput" class="form-label">{{$t('address')}}</label>
                            <div class="input-group">
                                <span class="input-group-text bg-light border-end-0">
                                    <AppIcon name="bi-house" class="bi bi-house" />
                                </span>
                                <textarea 
                                    v-model="supplier.address" 
                                    class="form-control border-start-0 ps-0" 
                                    id="createAddressInput" 
                                    rows="2"
                                ></textarea>
                            </div>
                        </div>
                        <div v-if="isSupplierFieldVisible('city')" class="supplier-create-field">
                            <label for="createCityInput" class="form-label">{{$t('city')}}</label>
                            <input v-model="supplier.city" type="text" class="form-control" id="createCityInput">
                        </div>
                        <div v-if="isSupplierFieldVisible('state')" class="supplier-create-field">
                            <label for="createStateInput" class="form-label">{{$t('state')}}</label>
                            <input v-model="supplier.state" type="text" class="form-control" id="createStateInput">
                        </div>
                        <div v-if="isSupplierFieldVisible('zip_code')" class="supplier-create-field">
                            <label for="createZipInput" class="form-label">{{$t('zip_code')}}</label>
                            <input v-model="supplier.zip_code" type="text" class="form-control" id="createZipInput">
                        </div>
                        <div v-if="isSupplierFieldVisible('country')" class="supplier-create-field">
                            <label for="createCountryInput" class="form-label">{{$t('country')}}</label>
                            <input v-model="supplier.country" type="text" class="form-control" id="createCountryInput">
                        </div>
                        <div v-if="isSupplierFieldVisible('tax_id')" class="supplier-create-field">
                            <label for="createTaxIdInput" class="form-label">{{$t('tax_id')}}</label>
                            <div class="input-group">
                                <span class="input-group-text bg-light border-end-0">
                                    <AppIcon name="bi-hash" class="bi bi-hash" />
                                </span>
                                <input 
                                    v-model="supplier.tax_id" 
                                    type="text" 
                                    class="form-control border-start-0 ps-0" 
                                    id="createTaxIdInput"
                                >
                            </div>
                        </div>
                        <div v-if="isSupplierFieldVisible('vat_number')" class="supplier-create-field">
                            <label for="createVatNumberInput" class="form-label">{{$t('vat_number')}}</label>
                            <div class="input-group">
                                <span class="input-group-text bg-light border-end-0">
                                    <AppIcon name="bi-hash" class="bi bi-hash" />
                                </span>
                                <input 
                                    v-model="supplier.vat_number" 
                                    type="text" 
                                    class="form-control border-start-0 ps-0" 
                                    id="createVatNumberInput"
                                >
                            </div>
                        </div>
                        <div v-if="isSupplierFieldVisible('notes')" class="supplier-create-field supplier-create-field--full">
                            <collapsible-notes-field v-model="supplier.notes" id="supplier-create-notes" rows="2" />
                        </div>
                    </div>
                </div>
                <div class="modal-footer border-0 pt-0">
                    <button type="button" class="btn btn-light" data-bs-dismiss="modal">
                        <AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}
                    </button>
                    <button type="button" class="btn btn-success" :disabled="loading || !isFormValid" @click="save">
                        <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        <AppIcon name="bi-check-circle" v-else class="bi bi-check-circle me-2" />
                        {{$t('create')}}
                    </button>
                </div>
                </div>
            </div>
        </div>
        <!-- create modal -->


        <!-- Edit Modal -->
        <div class="modal fade" id="supplier-edit-modal" tabindex="-1" aria-labelledby="supplier-edit-modal" aria-hidden="true">
            <div class="modal-dialog modal-xl">
                <div class="modal-content modern-modal">
                <div class="modal-header border-0 pb-0">
                    <div>
                        <h5 class="modal-title mb-0">
                            <AppIcon name="bi-pencil-square" class="bi bi-pencil-square me-2" />
                            {{$t('edit_supplier')}}
                        </h5>
                    </div>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
                </div>
                <div class="modal-body pt-2" style="text-align:left">
                    <div class="row g-2">
                        <div class="col-md-4">
                            <label for="editLabelInput" class="form-label">
                                {{$t('label')}} <span class="text-danger">*</span>
                            </label>
                            <div class="input-group">
                                <span class="input-group-text bg-light border-end-0">
                                    <AppIcon name="bi-person" class="bi bi-person" />
                                </span>
                                <input 
                                    v-model="supplier.name" 
                                    type="text" 
                                    class="form-control border-start-0 ps-0" 
                                    :class="{'is-invalid': validationErrors.name}"
                                    id="editLabelInput"
                                    @blur="validateField('name')"
                                >
                            </div>
                            <div v-if="validationErrors.name" class="invalid-feedback d-block">
                                {{validationErrors.name}}
                            </div>
                        </div>
                        <div v-if="isSupplierFieldVisible('phone')" class="col-md-4">
                            <label for="editPhoneInput" class="form-label">
                                {{$t('phone')}} <span class="text-danger">*</span>
                            </label>
                            <div class="input-group">
                                <span class="input-group-text bg-light border-end-0">
                                    <AppIcon name="bi-telephone" class="bi bi-telephone" />
                                </span>
                                <input 
                                    v-model="supplier.phone" 
                                    type="tel" 
                                    class="form-control border-start-0 ps-0"
                                    :class="{'is-invalid': validationErrors.phone}"
                                    id="editPhoneInput"
                                    @blur="validateField('phone')"
                                >
                            </div>
                            <div v-if="validationErrors.phone" class="invalid-feedback d-block">
                                {{validationErrors.phone}}
                            </div>
                        </div>
                        <div v-if="isSupplierFieldVisible('email')" class="col-md-4">
                            <label for="editEmailInput" class="form-label">{{$t('email')}}</label>
                            <div class="input-group">
                                <span class="input-group-text bg-light border-end-0">
                                    <AppIcon name="bi-envelope" class="bi bi-envelope" />
                                </span>
                                <input 
                                    v-model="supplier.email" 
                                    type="email" 
                                    class="form-control border-start-0 ps-0"
                                    :class="{'is-invalid': validationErrors.email}"
                                    id="editEmailInput"
                                    @blur="validateField('email')"
                                >
                            </div>
                            <div v-if="validationErrors.email" class="invalid-feedback d-block">
                                {{validationErrors.email}}
                            </div>
                        </div>
                        <div v-if="isSupplierFieldVisible('address')" class="col-md-12">
                            <label for="editAddressInput" class="form-label">{{$t('address')}}</label>
                            <div class="input-group">
                                <span class="input-group-text bg-light border-end-0">
                                    <AppIcon name="bi-house" class="bi bi-house" />
                                </span>
                                <textarea 
                                    v-model="supplier.address" 
                                    class="form-control border-start-0 ps-0" 
                                    id="editAddressInput" 
                                    rows="2"
                                ></textarea>
                            </div>
                        </div>
                        <div v-if="isSupplierFieldVisible('city')" class="col-md-3">
                            <label for="editCityInput" class="form-label">{{$t('city')}}</label>
                            <input v-model="supplier.city" type="text" class="form-control" id="editCityInput">
                        </div>
                        <div v-if="isSupplierFieldVisible('state')" class="col-md-3">
                            <label for="editStateInput" class="form-label">{{$t('state')}}</label>
                            <input v-model="supplier.state" type="text" class="form-control" id="editStateInput">
                        </div>
                        <div v-if="isSupplierFieldVisible('zip_code')" class="col-md-3">
                            <label for="editZipCodeInput" class="form-label">{{$t('zip_code')}}</label>
                            <input v-model="supplier.zip_code" type="text" class="form-control" id="editZipCodeInput">
                        </div>
                        <div v-if="isSupplierFieldVisible('country')" class="col-md-3">
                            <label for="editCountryInput" class="form-label">{{$t('country')}}</label>
                            <input v-model="supplier.country" type="text" class="form-control" id="editCountryInput">
                        </div>
                        <div v-if="isSupplierFieldVisible('tax_id')" class="col-md-6">
                            <label for="editTaxIdInput" class="form-label">{{$t('tax_id')}}</label>
                            <div class="input-group">
                                <span class="input-group-text bg-light border-end-0">
                                    <AppIcon name="bi-hash" class="bi bi-hash" />
                                </span>
                                <input 
                                    v-model="supplier.tax_id" 
                                    type="text" 
                                    class="form-control border-start-0 ps-0" 
                                    id="editTaxIdInput"
                                >
                            </div>
                        </div>
                        <div v-if="isSupplierFieldVisible('vat_number')" class="col-md-6">
                            <label for="editVatNumberInput" class="form-label">{{$t('vat_number')}}</label>
                            <div class="input-group">
                                <span class="input-group-text bg-light border-end-0">
                                    <AppIcon name="bi-hash" class="bi bi-hash" />
                                </span>
                                <input 
                                    v-model="supplier.vat_number" 
                                    type="text" 
                                    class="form-control border-start-0 ps-0" 
                                    id="editVatNumberInput"
                                >
                            </div>
                        </div>
                        <div v-if="isSupplierFieldVisible('notes')" class="col-md-12">
                            <collapsible-notes-field v-model="supplier.notes" id="supplier-edit-notes" rows="2" />
                        </div>
                    </div>
                </div>
                <div class="modal-footer border-0 pt-0">
                    <button type="button" class="btn btn-light" data-bs-dismiss="modal">
                        <AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}
                    </button>
                    <button type="button" class="btn btn-success" :disabled="loading || !isFormValid" @click="update">
                        <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        <AppIcon name="bi-pencil" v-else class="bi bi-pencil me-2" />
                        {{$t('update')}}
                    </button>
                </div>
                </div>
            </div>
        </div>
        <!-- Edit modal -->

  </div>
</template>

<script>
import helper from '../../helper'
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable'
import moment from 'moment'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import ImportSupplier from '../../components/ImportSupplier.vue'
import { getCrmTableColumnDefaults } from '../../constants/crmTableColumns'
import { getCrmSupplierFormFieldDefaults } from '../../constants/crmSupplierFormFields'
import sortableList from '../../mixins/sortableList'

export default {
  name: 'Supplier',
  persistedFilterState: {
    key: 'suppliers',
    fields: ['search', 'activeFilters', 'dateRangeOption', 'range', 'start', 'end', 'per_page', 'sortField', 'sortDirection'],
    dateFields: ['range'],
  },
  mixins: [sortableList],
  components : {
    DatePicker,
    ImportSupplier,
  },
  data(){
    return {
        uploadModal: null,
        search : '',
        count : 0,
        suppliers : [],
        supplier : {
            id : null,
            name : '',
            email : '',
            phone : '',
            address : '',
            notes : '',
            city: '',
            state: '',
            zip_code: '',
            country: '',
            tax_id: '',
            vat_number: ''
        },
        per_page : 25,
        range: [],
        start : null,
        end : null,
        dateRangeOption: '',
        activeFilters: [],
        availableFilters: [
            { key: 'name' },
            { key: 'email' },
            { key: 'phone' },
            { key: 'address' },
            { key: 'city' },
            { key: 'country' },
            { key: 'tax_id' },
            { key: 'vat_number' }
        ],
        createModal : null,
        editModal : null,
        loading : false,
        pagination : [],
        url : '',
        showFilters: false,
        searchTimeout : null,
        validationErrors: {},
        isSelectedItem: false,
        visibleColumns: getCrmTableColumnDefaults('suppliers')
    }
  },
  mounted(){
    if(helper.checkAccess('view_suppliers') == -1) return this.$router.push({path : '/'})
    if(helper.checkAccess('view_suppliers') == -2) return this.$router.push({path : '/subscribe'})
    this.loadColumnSettings()
    this.getSuppliers()
    // eslint-disable-next-line no-undef
    this.createModal = new bootstrap.Modal(document.getElementById('supplier-create-modal'))
    // eslint-disable-next-line no-undef
    this.editModal = new bootstrap.Modal(document.getElementById('supplier-edit-modal'))
  },
  methods: {
    isSupplierFieldVisible(field) {
        return this.supplierFormFields[field] !== false
    },
    truncateEntityName(name) {
        if (!name) return '-'
        return name.length > 20 ? `${name.slice(0, 20)}...` : name
    },
    loadColumnSettings() {
        const savedColumns = this.business?.metadata?.crm_suppliers_columns
        if (savedColumns) {
            this.visibleColumns = {
                ...getCrmTableColumnDefaults('suppliers'),
                ...savedColumns
            }
        }
    },
    truncateAddress(address, maxWords = 5, maxCharacters = 35) {
        if (!address) return '-'

        const normalizedAddress = String(address).trim().split(/\s+/).join(' ')
        const words = normalizedAddress.split(' ')

        if (words.length > maxWords) {
            return `${words.slice(0, maxWords).join(' ')}...`
        }

        if (normalizedAddress.length > maxCharacters) {
            return `${normalizedAddress.slice(0, maxCharacters).trim()}...`
        }

        return normalizedAddress
    },
    invoiceOutstandingAmount(invoice) {
        if (!invoice) return 0

        const status = String(invoice.status || '').toLowerCase()
        if (['canceled', 'draft'].includes(status)) return 0

        const total = parseFloat(invoice.total) || 0
        const paid = parseFloat(invoice.amount_paid) || 0
        return Math.max(total - paid, 0)
    },
    supplierBalanceDue(supplier) {
        return (supplier.invoices || []).reduce((sum, invoice) => {
            return sum + this.invoiceOutstandingAmount(invoice)
        }, 0)
    },
    supplierOverdueAmount(supplier) {
        const today = moment().startOf('day')

        return (supplier.invoices || []).reduce((sum, invoice) => {
            const outstanding = this.invoiceOutstandingAmount(invoice)
            if (outstanding <= 0) return sum

            const status = String(invoice.status || '').toLowerCase()
            const isPastDue = invoice.due_date && moment(invoice.due_date).isBefore(today)

            return status === 'overdue' || isPastDue ? sum + outstanding : sum
        }, 0)
    },
    showUpload(){
        // eslint-disable-next-line no-undef
        this.uploadModal = new bootstrap.Modal(document.getElementById('uploadModal'))
        this.uploadModal.show()
    },
    uploadSuccess(){
        this.uploadModal.hide()
        this.getSuppliers()
        this.$toast.open({
            message: this.$t('suppliers_imported_successfully'),
            type: 'success',
            position: 'bottom'
        })
    },
    generatePDF() {
        const doc = new jsPDF()
        
        // Add title
        doc.setFontSize(18)
        doc.text(this.$t('suppliers_list'), 14, 22)
        
        // Add date
        doc.setFontSize(11)
        doc.text(helper.formatDate(new Date()), 14, 30)
        
        // Define columns
        const columns = [
            { header: this.$t('reference'), dataKey: 'reference' },
            { header: this.$t('name'), dataKey: 'name' },
            { header: this.$t('phone'), dataKey: 'phone' },
            { header: this.$t('email'), dataKey: 'email' },
            { header: this.$t('address'), dataKey: 'address' },
            { header: this.$t('created_at'), dataKey: 'created_at' }
        ]
        
        // Prepare data
        const data = this.suppliers.map(supplier => ({
            reference: supplier.reference,
            name: supplier.name,
            phone: supplier.phone || '-',
            email: supplier.email || '-',
            address: supplier.address || '-',
            created_at: helper.formatDate(supplier.created_at)
        }))
        
        // Generate table
        autoTable(doc, {
            head: [columns.map(col => col.header)],
            body: data.map(row => columns.map(col => row[col.dataKey])),
            startY: 35,
            theme: 'grid',
            styles: { fontSize: 8 },
            headStyles: { fillColor: [41, 128, 185] }
        })
        
        // Save PDF
        doc.save('suppliers_list.pdf')
    },

    async getSuppliers(page){
        try{
            this.loading = true
            this.page = page ? page : 1

            // Build query params
            const params = new URLSearchParams();
            params.append('page', this.page);
            params.append('per_page', this.per_page);
            this.appendSortParams(params);

            if (this.start) {
                params.append('start', this.start);
                params.append('end', this.end);
            }

            if (this.search && this.search.length > 0) {
                params.append('keyword', this.search);
            }

            // Add Shopify-style active filters
            for (const filter of this.activeFilters) {
                if (filter.value && filter.value.toString().trim() !== '') {
                    params.append(filter.key, filter.value);
                }
            }

            let url = `${process.env.VUE_APP_API}/suppliers?${params.toString()}`;

            this.suppliers = []
            
            const response = await helper.customGet(url)
            this.suppliers =  response.data.data
            
            for(let i = 0 ; i < this.suppliers.length ; i++){
                this.$set(this.suppliers[i], 'selected', false)
            }

            this.count = response.data.count
            if(this.per_page != response.data.per_page){
                this.per_page = response.data.per_page
            }

            //pagination
            this.pagination = []
            let MaxPagination = Math.ceil(this.count / this.per_page )
            for(let i = 1 ; i <= MaxPagination ;i++){
                this.pagination.push(i)
            }

            this.loading = false
        }catch(error){
            this.loading = false
        }

    },
    create(){
        this.supplier = {
            id : null,
            name : '',
            phone : '',
            email : '',
            address : '',
            notes : '',
            city: '',
            state: '',
            zip_code: '',
            country: '',
            tax_id: '',
            vat_number: ''
        }
        this.validationErrors = {}
        this.createModal.show()
    },
    async save(){
        if(this.validateForm()){
            try{
                this.loading = true
                await helper.customPost(`${process.env.VUE_APP_API}/suppliers`, this.supplier, {showToast:true})
                this.loading = false
                this.createModal.hide()
                this.getSuppliers()
            }catch(error){
                this.loading = false
                if(error.response && error.response.data && error.response.data.errors){
                    this.validationErrors = error.response.data.errors
                }
            }
        }
    },
    editRow(row){
        this.supplier = {...row}
        this.validationErrors = {}
        this.editModal.show()
    },
    async update(){
        if(this.validateForm()){
            try{
                this.loading = true
                await helper.customPatch(`${process.env.VUE_APP_API}/suppliers/${this.supplier.id}`, this.supplier, {showToast:true})
                this.loading = false
                this.editModal.hide()
                this.getSuppliers()
            }catch(error){
                this.loading = false
                if(error.response && error.response.data && error.response.data.errors){
                    this.validationErrors = error.response.data.errors
                }
            }
        }
    },
    async deleteRow(row){
        this.$swal.fire({
            title: this.$t('are_you_sure'),
            text: this.$t('you_wont_be_able_to_revert_this'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('yes_delete_it')
        }).then(async (result) => {
            if (result.isConfirmed) {
                try{
                    await helper.customDelete(`${process.env.VUE_APP_API}/suppliers/${row.id}`, {showToast:true})
                    this.suppliers = helper.withoutDeletedRecords(this.suppliers, row.id)
                    this.count = Math.max(0, this.count - 1)
                }catch(error){
                    //
                }
            }
        })
    },
    goDetails(id){
        this.$router.push({path: `/suppliers/${id}`, params : { id }});
    },
    validateField(field){
        if(!this.isSupplierFieldVisible(field)){
            this.$set(this.validationErrors, field, null)
            return
        }
        if(this.supplier[field] && this.supplier[field].length > 0){
            this.$set(this.validationErrors, field, null)
        }
    },
    validateForm(){
        this.validationErrors = {}
        let isValid = true
        if(!this.supplier.name){
            this.validationErrors.name = this.$t('field_required')
            isValid = false
        }
        if(this.isSupplierFieldVisible('phone') && !this.supplier.phone){
            this.validationErrors.phone = this.$t('field_required')
            isValid = false
        }
        return isValid
    },
    formatDate(date){
        return helper.formatDate(date)
    },
    formatMoney(money){
        return helper.formatMoney(money)
    },
    addFilter(filter) {
        if (!this.isFilterActive(filter.key)) {
            this.activeFilters.push({ 
                key: filter.key, 
                value: '' 
            });
        }
    },
    removeFilter(index) {
        this.activeFilters.splice(index, 1);
    },
    isFilterActive(key) {
        return this.activeFilters.some(f => f.key === key);
    },
    applyFilters() {
        this.getSuppliers();
    },
    clearAllFilters() {
        this.activeFilters = [];
        this.getSuppliers();
    },
    debouncedSearch(){
        // Clear existing timeout
        if(this.searchTimeout) {
            clearTimeout(this.searchTimeout)
        }
        
        // Set new timeout
        this.searchTimeout = setTimeout(() => {
            this.getSuppliers()
        }, 500) // 500ms delay
    },
    changeSelectedItem(){
        this.isSelectedItem = this.suppliers.find(supplier => supplier.selected === true ) ? true : false
    },
    toggleSelectAll() {
      const newState = !this.areAllSelected;
      this.suppliers.forEach(s => s.selected = newState);
      this.changeSelectedItem();
    },
    async deleteSelected() {
      const selectedIds = this.suppliers.filter(s => s.selected).map(s => s.id);
      if (selectedIds.length === 0) return;

      this.$swal.fire({
        title: `${this.$t('are_you_sure')}?`,
        text: this.$t('you_cant_revert'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes_delete_it')
      }).then(async (result) => {
        if (result.isConfirmed) {
            this.loading = true;
            try {
                const results = await Promise.allSettled(selectedIds.map(id => helper.customDelete(`${process.env.VUE_APP_API}/suppliers/${id}`)));
                const deletedIds = helper.fulfilledRecordIds(selectedIds, results);
                this.suppliers = helper.withoutDeletedRecords(this.suppliers, deletedIds);
                this.count = Math.max(0, this.count - deletedIds.length);
                if (deletedIds.length !== selectedIds.length) throw results.find(result => result.status === 'rejected').reason;
                this.isSelectedItem = false;
                this.$toast.open({
                    message: this.$t('suppliers_deleted_successfully'),
                    type: 'success',
                    position: 'bottom'
                });
            } catch (error) {
                this.$toast.open({
                    message: this.$t('error_occurred'),
                    type: 'error',
                    position: 'bottom'
                });
            } finally {
                this.loading = false;
            }
        }
      });
    },
    // Handle date range selection
    handleDateRangeChange() {
      if (this.dateRangeOption === '') {
        // All dates - clear range
        this.range = []
        this.start = null
        this.end = null
        this.getSuppliers()
      } else if (this.dateRangeOption === 'today') {
        const start = new Date()
        const end = new Date()
        this.range = [start, end]
      } else if (this.dateRangeOption === 'yesterday') {
        const start = new Date()
        const end = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24)
        end.setTime(end.getTime() - 3600 * 1000 * 24)
        this.range = [start, end]
      } else if (this.dateRangeOption === 'this_week') {
        const start = new Date()
        const end = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
        this.range = [start, end]
      } else if (this.dateRangeOption === 'last_week') {
        const start = new Date()
        const end = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 14)
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
        this.range = [start, end]
      } else if (this.dateRangeOption === 'this_month') {
        const start = new Date()
        const end = new Date()
        start.setDate(1)
        this.range = [start, end]
      } else if (this.dateRangeOption === 'custom') {
        // Don't set range yet, wait for user to pick dates
        this.range = []
      }
    }
  },
  watch : {
    search(){
        if(this.search.length > 2 || this.search.length === 0){
            this.debouncedSearch()
        }
    },
    range(){

        if(this.range[0] == null){
            this.start = null
            this.end = null
            this.getSuppliers()
        }

        if(this.range.length && this.range[0] && this.range[1]){
            this.start = moment(this.range[0]).format('YYYY-MM-DD')
            this.end = moment(this.range[1]).format('YYYY-MM-DD')
            this.getSuppliers()
        }else{
            this.suppliers = []
        }

    },
    per_page(){
        this.getSuppliers(this.page)
    }
  },
  computed : {
    selectableFilters() {
        return this.availableFilters.filter(f => !this.isFilterActive(f.key));
    },
    isFiltered() {
      return (this.activeFilters.length > 0) || 
             (this.search && this.search.length > 0) ||
             (this.dateRangeOption && this.dateRangeOption !== '') ||
             (this.range && this.range.length > 0);
    },
    role(){ return this.$store.getters.ROLE },
    business(){ return this.$store.getters.BUSINESS},
    supplierFormFields(){
        return {
            ...getCrmSupplierFormFieldDefaults(),
            ...(this.business?.metadata?.crm_supplier_form_fields || {}),
            name: true
        }
    },
    helper(){ return helper },
    isFormValid() {
        const hasRequiredPhone = !this.isSupplierFieldVisible('phone') || !!this.supplier.phone
        const hasValidEmail = !this.isSupplierFieldVisible('email') || !this.supplier.email || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.supplier.email)
        return this.supplier.name && 
               this.supplier.name.trim().length >= 2 && 
               hasRequiredPhone &&
               hasValidEmail
    },
    areAllSelected() {
      return this.suppliers.length > 0 && this.suppliers.every(s => s.selected);
    },
    selectedCount() {
      return this.suppliers.filter(s => s.selected).length;
    }
  }
}
</script>

<style scoped>
    .supplier-create-fields {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;
    }

    .supplier-create-field {
        flex: 1 1 15rem;
        min-width: 0;
    }

    .supplier-create-field--full {
        flex-basis: 100%;
    }

    .table-borderless>:not(caption)>*>*{
        padding: 5px !important
    }

    .supplier-address {
        display: inline-block;
        max-width: 220px;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: middle;
        white-space: nowrap;
    }
    
    .advanced-search-section {
        background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
        border: 1px solid #dee2e6;
        border-radius: 8px;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }
    
    .filter-input {
        transition: all 0.3s ease;
    }
    
    .filter-input:focus {
        border-color: #303030;
        box-shadow: 0 0 0 0.2rem rgba(83, 77, 255, 0.25);
    }
    
    .btn-outline-primary {
        border-color: #cbd5e1;
        color: #334155;
    }
    
    .btn-outline-primary:hover {
        background-color: #004aad;
        border-color: #004aad;
        color: white;
    }
    
    .btn-outline-primary.active {
        background-color: #004aad;
        border-color: #004aad;
        color: white;
    }

    /* Modern Modal Styles */
    .modern-modal {
        border: none;
        border-radius: 16px;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
    }

    .modern-modal .modal-header {
        padding: 1rem 1.5rem 0.75rem;
        background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
    }

    .modern-modal .modal-title {
        font-weight: 600;
        color: #2c3e50;
    }

    .modern-modal .modal-body {
        padding: 1rem 1.5rem;
        max-height: 70vh;
        overflow-y: auto;
    }

    .modern-modal .modal-footer {
        padding: 0.75rem 1.5rem 1rem;
        background-color: #f8f9fa;
        border-bottom-left-radius: 16px;
        border-bottom-right-radius: 16px;
    }

    /* Enhanced Input Styles */
    .input-group-text {
        background-color: #f8f9fa;
        border-color: #dee2e6;
        color: #6c757d;
        transition: all 0.3s ease;
    }

    .input-group:focus-within .input-group-text {
        background-color: #e9ecef;
        color: #495057;
        border-color: #80bdff;
    }

    .form-control {
        border-color: #dee2e6;
        transition: all 0.3s ease;
    }

    .form-control:focus {
        border-color: #80bdff;
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.15);
    }

    .form-control.is-invalid {
        border-color: #dc3545;
        background-image: none;
    }

    .form-control.is-invalid:focus {
        box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.15);
    }

    /* Form Label Styles */
    .form-label {
        font-size: 0.85rem;
        font-weight: 500;
        color: #495057;
        margin-bottom: 0.375rem;
    }

    .form-label .text-danger {
        font-size: 1rem;
        margin-left: 2px;
    }

    /* Invalid Feedback Styles */
    .invalid-feedback {
        font-size: 0.8125rem;
        margin-top: 0.25rem;
        animation: slideDown 0.3s ease;
    }

    @keyframes slideDown {
        from {
            opacity: 0;
            transform: translateY(-5px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    /* Button Styles */
    .btn {
        font-weight: 500;
        padding: 0.5rem 1.25rem;
        border-radius: 8px;
        transition: all 0.3s ease;
    }

    .btn-light {
        background-color: #f8f9fa;
        border-color: #dee2e6;
        color: #495057;
    }

    .btn-light:hover {
        background-color: #e2e6ea;
        border-color: #dae0e5;
        color: #495057;
    }

    .btn-success {
        background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
        border: none;
        box-shadow: 0 2px 8px rgba(40, 167, 69, 0.2);
    }

    .btn-success:hover {
        background: linear-gradient(135deg, #218838 0%, #1aa179 100%);
        box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
        transform: translateY(-1px);
    }

    .btn-success:disabled {
        background: linear-gradient(135deg, #6c757d 0%, #868e96 100%);
        box-shadow: none;
        cursor: not-allowed;
        opacity: 0.65;
    }

    /* Scrollbar Styles for Modal Body */
    .modal-body::-webkit-scrollbar {
        width: 8px;
    }

    .modal-body::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
    }

    .modal-body::-webkit-scrollbar-thumb {
        background: #cbd5e0;
        border-radius: 10px;
    }

    .modal-body::-webkit-scrollbar-thumb:hover {
        background: #a0aec0;
    }

    /* Textarea Styles */
    textarea.form-control {
        resize: vertical;
        min-height: 60px;
    }

    /* Responsive Adjustments */
    @media (max-width: 768px) {
        .modern-modal .modal-header,
        .modern-modal .modal-body,
        .modern-modal .modal-footer {
            padding-left: 1rem;
            padding-right: 1rem;
        }

        .modal-xl {
            max-width: 95%;
        }
    }
</style>
